import Menu from 'layout/LandingPageLayout/Menu'
import Image from 'next/image'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { FC, useCallback, useEffect, useState } from 'react'
import {
  Button,
  Col,
  Container,
  Dropdown,
  Nav,
  Navbar,
  Row,
} from 'react-bootstrap'
// import imageLogo from '../../../../public/assets/images/logo.svg'
// import imageLogoBlue from '../../../../public/assets/images/logo_blue.svg'
import {
  HeaderServiceConstant,
  HeaderTechConstant,
  ServicesInterface,
  TechnologyInterface,
} from '../../../constants/HeaderTabConstant'
import LinkButton from 'components/LinkButton'

const imageLogo = '/assets/images/logo.svg'
const imageLogoBlue = '/assets/images/logo_blue.svg'
interface Props {
  isErrorCls?: any
}
const Header: FC<Props> = ({ isErrorCls }) => {
  const router = useRouter()
  const [scroll, setScroll] = useState(false)
  // const [sticky, setSticky] = useState(true)
  const checkErrorPage = isErrorCls

  // const getBlogDetailsClass =
  //   typeof document !== 'undefined' && document.querySelector('.error-page')

  const getBlogDetailsClass = document.body.classList.contains('error-page')

  useEffect(() => {
    window.addEventListener('scroll', () => {
      setScroll(window.scrollY > 50)
    })
  }, [])
  const [MenuShow, setMenuShow] = useState(false)
  const [MenuAnimate, setMenuAnimate] = useState(0)
  const handleMenu = () => {
    if (MenuShow && MenuAnimate === 1) {
      setMenuShow(!MenuShow)
      setMenuAnimate(2)
      // setSticky(!sticky)
    } else {
      setMenuAnimate(1)
      // setSticky(!sticky)
      setTimeout(() => {
        setMenuShow(!MenuShow)
      }, 800)
    }
    // setMenuAnimate(!MenuAnimate)
    // setMenuShow(!MenuShow)
  }
  useEffect(() => {
    document.body.classList.toggle('overflow_hidden', MenuShow)
  }, [MenuShow])
  const [show, setShow] = useState(false)
  const [show2, setShow2] = useState(false)

  useEffect(() => {
    const closeMenu = () => {
      setMenuShow(false)
      setShow(false)
      setShow2(false)
      setMenuAnimate(0)
    }
    router.events.on('routeChangeStart', closeMenu)
    return () => router.events.off('routeChangeStart', closeMenu)
  }, [router.events])

  const RenderTabOption = useCallback((Options: any) => {
    return (
      <>
        {Options.map(
          ({
            className,
            title,
            titleNoLink,
            description,
            tags,
            id,
            link,
          }: TechnologyInterface) => (
            <Col md={3} key={id} className={className}>
              <div className="inner_block d-flex flex-column h-100">
                <div className="dd_title text-decoration-none">
                  {titleNoLink}
                </div>
                <Link href={link} className="dd_title text-decoration-none">
                  {title}
                </Link>
                <p className="text_grey mb-0">{description}</p>
                <ul className="link_small mb-0">
                  {tags.length > 0 &&
                    tags.map(({ tag, sublink, subid }: any) => (
                      <li key={subid}>
                        <Link href={sublink} legacyBehavior>
                          {tag}
                        </Link>
                      </li>
                    ))}
                </ul>
              </div>
            </Col>
          )
        )}
      </>
    )
  }, [])

  const RenderTabOptionTechnology = useCallback((Options: any) => {
    return (
      <>
        {Options.map(
          ({
            className,
            title,
            titleNoLink,
            description,
            tags,
            id,
            link,
          }: ServicesInterface) => (
            <Col md={4} key={id} className={className}>
              <div className="inner_block d-flex flex-column h-100">
                <div className="dd_title text-decoration-none">
                  {titleNoLink}
                </div>
                <Link href={link} className="dd_title text-decoration-none">
                  {title}
                </Link>
                <p className="text_grey mb-0">{description}</p>
                <ul className="link_small mb-0">
                  {tags.length > 0 &&
                    tags.map(({ tag, sublink, subid }: any) => (
                      <li key={subid}>
                        <Link href={sublink} legacyBehavior>
                          {tag}
                        </Link>
                      </li>
                    ))}
                </ul>
              </div>
            </Col>
          )
        )}
      </>
    )
  }, [])

  const dateChecker = () => {
    // Added One hour in current time for sticky Active-DeActive
    const currentTimeInSeconds = Math.floor(new Date().getTime() / 1000)
    const expireTimeInSeconds = currentTimeInSeconds + 3600
    localStorage.setItem('expireTime', expireTimeInSeconds.toString())

    // 2 min Add For Testing
    // const currentTimeStamp1 = Math.floor(Date.now() / 1000)
    // const twoMinutesLater = currentTimeStamp1 + 2 * 60
    // localStorage.setItem('expireTime', twoMinutesLater.toString())

    console.log(expireTimeInSeconds, 'expireTimeInSeconds======-=-=-=-==')
  }

  return (
    <>
      {/* {!PageUrlCheck && sticky && (
      <div className="sticky_msg">
        <a
          className="close"
          role="button"
          tabIndex={0}
          onClick={() => {
            dateChecker()
            // setSticky(false)
          }}
        >
          <div>
            <img
              src="assets/images/close-white.svg"
              className="icon"
              alt=""
            />
          </div>
        </a>
        <div className="sticky_msg_content">
          <div className="left_side">
            <img src="assets/images/icon-dubai.png" className="icon" alt="" />
            <div className="p1">We’re in Dubai</div>
          </div>
          <div className="right_side">
            <div className="p2">
              17<sup>th</sup> May - 05<sup>th</sup> June 2023
            </div>
            <a href="/contact-us" className="connect">
              Let’s Connect
            </a>
          </div>
        </div>
      </div>
    )} */}

      <Navbar
        expand="xl"
        variant="dark"
        fixed="top"
        data-aos="fade-in"
        className={`nav_main ${scroll ? 'sticky_nav' : ''}`}
      >
        <Container className="position-relative">
          <Navbar.Brand href="/">
            {(checkErrorPage && !scroll) || (getBlogDetailsClass && !scroll) ? (
              <Image
                src={imageLogoBlue}
                className="img-fluid"
                alt="Webclues Infotech"
                data-aos="zoom-in"
                data-aos-delay="100"
                data-aos-easing="ease-out-quart"
                data-aos-duration="700"
                width="380"
                height="70"
                style={{
                  maxWidth: '100%',
                  height: 'auto',
                }}
              />
            ) : (
              <Image
                src={imageLogo}
                className="img-fluid"
                alt="Webclues Infotech"
                data-aos="zoom-in"
                data-aos-delay="100"
                data-aos-easing="ease-out-quart"
                data-aos-duration="700"
                width="380"
                height="70"
                style={{
                  maxWidth: '100%',
                  height: 'auto',
                }}
              />
            )}
          </Navbar.Brand>
          <Navbar.Toggle
            className="ms-auto me-3 d-none"
            aria-controls="responsive-navbar-nav"
          />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="ms-auto mt-4 mt-lg-0 align-items-center">
              <Dropdown
                className="position-static me-4 servicesDropdown"
                show={show}
                onMouseEnter={() => setShow(true)}
                onMouseLeave={() => setShow(false)}
              >
                <Dropdown.Toggle
                  onClick={() => {
                    router.push('/it-solutions')
                  }}
                  variant="alink"
                  className="nav-link revert_link"
                >
                  <span className="name_1">Services</span>
                  <span className="name_2">Services</span>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Row className="align-items-center">
                    <Col md={3} className="ps-4 customized_services_box4">
                      <div className="menu_left_block d-flex flex-column ms-4 my-4">
                        <p className="text1">Customized Solutions</p>
                        <h4 className="title_md mt-auto mb-0">
                          Transforming Problems into Solutions
                        </h4>
                      </div>
                    </Col>
                    <Col md={9} className="ps-2 pe-4 nav_menu_services_box4">
                      <Row className="align-items-stretch">
                        {RenderTabOption(HeaderServiceConstant)}
                      </Row>
                    </Col>
                  </Row>
                </Dropdown.Menu>
              </Dropdown>
              <Dropdown
                className="position-static me-4"
                show={show2}
                onMouseEnter={() => setShow2(true)}
                onMouseLeave={() => setShow2(false)}
              >
                <Dropdown.Toggle
                  onClick={() => {
                    router.push('/technology')
                  }}
                  variant="alink"
                  className="nav-link revert_link"
                >
                  <span className="name_1">Technology</span>
                  <span className="name_2">Technology</span>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Row className="align-items-center">
                    <Col md={3} className="ps-4">
                      <div className="menu_left_block d-flex flex-column ms-4 my-4">
                        <p className="text1">Technology stack we work on</p>
                        <h4 className="title_md mt-auto mb-0">
                          The building blocks of our solutions
                        </h4>
                      </div>
                    </Col>
                    <Col md={9} className="ps-4">
                      <Row className="align-items-stretch">
                        {RenderTabOptionTechnology(HeaderTechConstant)}
                      </Row>
                    </Col>
                  </Row>
                </Dropdown.Menu>
              </Dropdown>
              <Link
                href="/portfolio"
                className="top-nav-link mx-0 mx-lg-3 mb-2 mb-xl-0 mt-1 mt-xl-0 revert_link"
              >
                <span className="name_1">Work</span>
                <span className="name_2">Work</span>
              </Link>
            </Nav>
            <LinkButton className="mx-3" path="/get-quote">
              <Image
                src="/assets/images/gq-icon.png"
                className="me-2"
                alt="img"
                width={14}
                height={20}
              />
              GET QUOTE
            </LinkButton>
          </Navbar.Collapse>
          <Button
            variant="link"
            onClick={handleMenu}
            className="p-0 menuButton2"
          >
            ME
            <br />
            NU
          </Button>
          <div className="menuAnimateWrap">
            {MenuAnimate === 1 && <div className="menuAnimate" />}
            {MenuAnimate === 2 && <div className="menuAnimateClose" />}
            {/* <div className="menuAnimate" /> */}
          </div>
        </Container>
      </Navbar>
      {MenuShow && <Menu handleMenu={handleMenu} />}
    </>
  )
}

export default Header
